import React from 'react';
import {playbackRateList} from 'lib/playUtils';
import {t} from 'lib/i18n';

/**
 * 재생속도 컴포넌트
 */

interface IPlaybackRateProps {
  setSettingList: React.Dispatch<React.SetStateAction<string>>;
  stateRate: number;
  onClickPlaybackRate: (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => void;
}

const PlaybackRate = ({
  setSettingList,
  stateRate,
  onClickPlaybackRate,
}: IPlaybackRateProps) => {
  /**
   * 이전 클릭 함수
   * @param e
   */
  const onClickBefore = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    e.preventDefault();

    setSettingList('');
  };

  return (
    <div className='setting_list_subLayer speed'>
      <button className='goBack' onClick={onClickBefore}>
        {t('재생 속도')}
      </button>
      <ul>
        {playbackRateList.map((rate, idx) => (
          <li key={idx}>
            <button
              type='button'
              className={stateRate === rate ? 'on' : ''}
              data-rate={rate}
              onClick={onClickPlaybackRate}>
              {rate === 1 ? t('기본') : `${rate}x`}
              <em></em>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PlaybackRate;
